<template>
  <Layout>
    <PageHeader :title="title" style="display:none" />
    <div class="row">
      <div class="col-md-12">
        <div class="card mt-4">
          <div class="card-title mx-auto mt-4 text-center">
            <img src="../../../assets/icons/padlock.png" alt />
            <h2 class="text-center mt-4">{{ $t('pages.unautorized.title') }}</h2>
          </div>
          <div class="card-body text-center">
            <p class="text-center text-muted">{{ $t('pages.unauthorized.content') }}</p>
            <router-link
              :to="{ path: '/' }"
              class="btn btn-primary mt-2 mb-4"
            >{{ $t('pages.unauthorized.return') }}</router-link>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

export default {
  page: {
    title: "Autorisation",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },

  data() {
    return {
      title: "Autorisation",
    };
  },
};
</script>

<style>
</style>